"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const StyledLink = styled_components_1.default.div `
&&& {
  ${props => props.customStyles}
}
  display: inline-block;
  font-size: 16px;
  font-family: Nimbus Sans Regular;
  line-height: 1.38;
  outline: none;
  letter-spacing: normal;
  cursor: pointer;
  color: ${({ color }) => (color ? color : tokens.ColorBrandInteractiveBlue)};
  a {
    color: ${({ color }) => (color ? color : tokens.ColorBrandInteractiveBlue)};
    text-decoration: ${({ underline }) => (underline ? "underline" : "none")};
    :hover {
      color: ${({ hoverColor }) => hoverColor && hoverColor};
      text-decoration: ${({ hoverColor }) => !hoverColor && "underline"};
    }
  }
  span:first-child {
    text-decoration: ${({ underline }) => underline && "underline"};
  }
  :hover {
    color: ${({ hoverColor }) => hoverColor && hoverColor};
    span:first-child {
      text-decoration: ${({ hoverColor }) => !hoverColor && "underline"};
    }
`;
class Link extends react_1.Component {
    render() {
        const _a = this.props, { color, underline, onClick, hoverColor, linkLabel, registeredTradeMark, customStyles, href, id } = _a, rest = __rest(_a, ["color", "underline", "onClick", "hoverColor", "linkLabel", "registeredTradeMark", "customStyles", "href", "id"]);
        return (react_1.default.createElement(StyledLink, Object.assign({ underline: underline, color: color, hoverColor: hoverColor, onClick: onClick, customStyles: customStyles, id: id + '-container' }, rest),
            href && react_1.default.createElement("a", { href: href, id: id, tabIndex: -1 }, linkLabel || "Link"),
            !href && react_1.default.createElement("a", Object.assign({}, rest, { id: id, tabIndex: -1 }),
                " ",
                linkLabel || "Link"),
            registeredTradeMark && react_1.default.createElement("span", null, " \u00AE")));
    }
}
exports.default = Link;
//# sourceMappingURL=Link.js.map